export const itemsByCategory = {
  default: {
    defaultValue: null,
    items: [
      'newBuilding', // Новостройка/Строящееся
      'secondary', // Вторичный рынок
    ],
  },
  office: {
    defaultValue: 'operational',
    items: [
      'operational', // действующий
      'underConstruction', // строящийся
      'project', // проект
    ],
  },
  shoppingArea: {
    defaultValue: 'operational',
    items: [
      'operational', // действующий
      'underConstruction', // строящийся
      'project', // проект
    ],
  },
  freeAppointmentObject: {
    defaultValue: 'operational',
    items: [
      'operational', // действующий
      'underConstruction', // строящийся
      'project', // проект
    ],
  },
  building: {
    defaultValue: 'operational',
    items: [
      'operational', // действующий
      'underConstruction', // строящийся
      'project', // проект
    ],
  },
  industry: {
    defaultValue: 'operational',
    items: [
      'operational', // действующий
      'underConstruction', // строящийся
      'project', // проект
    ],
  },
  warehouse: {
    defaultValue: 'operational',
    items: [
      'operational', // действующий
      'underConstruction', // строящийся
      'project', // проект
    ],
  },
};

export default [
  {
    text: 'Новостройка/Строящееся',
    value: 'newBuilding',
  },
  {
    text: 'Действующее',
    value: 'operational',
  },
  {
    text: 'Проект',
    value: 'project',
  },
  {
    text: 'Вторичный рынок',
    value: 'secondary',
  },
  {
    text: 'Строящееся',
    value: 'underConstruction',
  },
];
